var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crag-routes',{attrs:{"crag":_vm.crag}}),_vm._v(" "),_c('client-only',[_c('crag-route-drawer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }